// Material 3 Progress Indicators Component
// Aligned with Google Material Web (material-components/material-web/docs/components/progress.md)
// Supports: Circular Progress and Linear Progress indicators
(function () {
  const { CircularProgress: MuiCircularProgress, LinearProgress: MuiLinearProgress } = MaterialUI;

  function CircularProgress({
    size = 24,
    color = 'primary',
    value,
    indeterminate = true,
    sx = {},
    ...props
  }) {
    const theme = MaterialUI.useTheme();
    const isDark = theme?.palette?.mode !== 'light';
    const colors = theme?.palette?.m3 || (isDark ? window.Components?.m3DarkColors : window.Components?.m3LightColors) || {};

    return (
      <MuiCircularProgress
        size={size}
        color={color}
        variant={indeterminate && value === undefined ? 'indeterminate' : 'determinate'}
        value={value}
        sx={{
          color: color === 'primary' ? (theme?.palette?.primary?.main || colors.primary || 'var(--m3-primary)') : undefined,
          ...sx
        }}
        {...props}
      />
    );
  }

  function LinearProgress({
    value,
    color = 'primary',
    indeterminate = false,
    sx = {},
    ...props
  }) {
    const theme = MaterialUI.useTheme();
    const isDark = theme?.palette?.mode !== 'light';
    const colors = theme?.palette?.m3 || (isDark ? window.Components?.m3DarkColors : window.Components?.m3LightColors) || {};

    return (
      <MuiLinearProgress
        variant={indeterminate || value === undefined ? 'indeterminate' : 'determinate'}
        value={value}
        color={color}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor:'color-mix(in srgb, var(--m3-on-surface) 10%, transparent)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 3,
            backgroundColor: color === 'error'
              ? (colors.error || (isDark ? '#f2b8b5' : '#ba1a1a'))
              : (color === 'primary' ? (theme?.palette?.primary?.main || colors.primary || 'var(--m3-primary)') : undefined)
          },
          ...sx
        }}
        {...props}
      />
    );
  }

  window.Components = window.Components || {};
  window.Components.CircularProgress = CircularProgress;
  window.Components.LinearProgress = LinearProgress;
})();
